import "./NotFound.css";

import React from "react";

const NotFound = () => {
  return (
    <div id='not-found'>
      <h1 className='text-center text-danger'>404 Not Found</h1>
    </div>
  );
};

export default NotFound;
